import "../styles/categories.css";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategoryData } from "../features/events/events_slice";

function CategoriesList() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.events.categoryData);

  const loading = useSelector((state) => state.events.categoryLoading);
  useEffect(() => {
    if (loading) dispatch(fetchCategoryData());
  }, [dispatch, loading]);

  return (
    <div className="grid-container">
      {data.map((item, index) => (
        <Link
          key={index + "CategoriesList"}
          to={`/${item.name}`}
          onClick={() => {
            sessionStorage.setItem("categoryScroll", window.scrollY);
          }}
          style={{ textDecoration: "none" }}
        >
          <div className="grid-item">
            <p className="category-title">{item.name}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}

export default CategoriesList;
